<template>
  <i
    v-if="icon"
    :class="['ui-icon', icon, { disabled: disabled }]"
    :aria-disabled="disabled"
    :style="iconStyle"
    @click="!disabled && emit('click', $event)"
  ></i>
</template>

<script setup lang="ts">
import { computed } from 'vue';
import { useColors } from '@/composables';

const props = withDefaults(defineProps<{
  icon: string;
  disabled?: boolean;
  color?: string;
  size?: string | number;
}>(), {
  size: '13',
  disabled: false,
});

const emit = defineEmits<{ click: [event: MouseEvent] }>();

const $colors = useColors();

const iconStyle = computed(() => ({
  fontSize: `${props.size}px`,
  color: props.disabled ? $colors.gray40 : (props.color || $colors.graphite),
}));

</script>

<style lang="scss" scoped>
.ui-icon {
  &.disabled {
    cursor: default;
    pointer-events: none;
  }
}
</style>
